import angular from 'angular';
import template from './video-chat-dropped-screen.html';
import './video-chat-dropped-screen.scss';
import { DroppedScreenServiceDoctor } from './common/services/dropped-screen-service-doctor';
import { DroppedScreenServicePatient } from './common/services/dropped-screen-service-patient';
class VideoChatDroppedScreenController {
    constructor($injector) {
        this.$injector = $injector;
    }
    $onInit() {
        if (this.isPatient) {
            this.droppedScreenService = new DroppedScreenServicePatient(this.$injector);
        }
        else {
            this.droppedScreenService = new DroppedScreenServiceDoctor(this.$injector);
        }
    }
}
const videoChatDroppedScreen = {
    template,
    bindings: {
        isPatient: '<',
    },
    controller: VideoChatDroppedScreenController,
};
export default angular
    .module('doxy.videoChat.common.components.videoChatDroppedScreen', [])
    // video-chat-dropped-screen
    .component('videoChatDroppedScreen', videoChatDroppedScreen).name;
